import { FC } from 'react';

type Props = {
  size?: number,
  className?: string,
};

// Stroke-based right arrow (shaft + head); inherits the parent's text colour
// via currentColor.
const ArrowRightOutlineIcon: FC<Props> = ({ size = 16, className }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 12h14"></path>
    <path d="M13 6l6 6-6 6"></path>
  </svg>
);

export default ArrowRightOutlineIcon;
